import { p as promiseResolve, b as bootstrapLazy } from './index-8956c047.js';
/*
 Stencil Client Patch Esm v2.6.0 | MIT Licensed | https://stenciljs.com
 */

var patchEsm = function patchEsm() {
  return promiseResolve();
};

var defineCustomElements = function defineCustomElements(win, options) {
  if (typeof window === 'undefined') return Promise.resolve();
  return patchEsm().then(function () {
    return bootstrapLazy([["dc-header_4", [[1, "dc-header", {
      "homepage": [1],
      "community": [1],
      "wordpress": [1],
      "returnurl": [1],
      "logo": [8],
      "logosmall": [8],
      "user": [32],
      "isShrink": [32],
      "scrollTop": [32],
      "isMenuOpen": [32],
      "isProfileMenuOpen": [32]
    }, [[9, "scroll", "handleScroll"], [0, "toggleMenu", "toggleMenuHandler"], [0, "toggleProfileMenu", "toggleProfileMenuHandler"], [0, "closeAll", "closeAll"]]], [1, "dc-menu", {
      "open": [4],
      "community": [1],
      "homepage": [1],
      "wordpress": [1],
      "host": [1],
      "user": [16]
    }, [[4, "keydown", "handleEscapeKey"]]], [1, "dc-profile", {
      "shrank": [4],
      "expanded": [4],
      "community": [1],
      "homepage": [1],
      "host": [1],
      "user": [16]
    }, [[4, "keydown", "handleEscapeKey"]]], [4, "dc-link", {
      "to": [1],
      "target": [1],
      "namespace": [1]
    }, [[2, "click", "handleClick"]]]]]], options);
  });
};

export { defineCustomElements };